import { render, staticRenderFns } from "./CustomViewEditor.vue?vue&type=template&id=5bced592&scoped=true"
import script from "./CustomViewEditor.vue?vue&type=script&lang=js"
export * from "./CustomViewEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bced592",
  null
  
)

export default component.exports